import React from "react"
import { GetServerSideProps } from "next"

import CourseDetailPage, { CourseDetailPageProps } from "@modules/course-detail/CourseDetailPage"
import CourseDetailRepo from "@api/server-side/course-detail.repo"

export const getServerSideProps: GetServerSideProps<any> = async (ctx) => {
  const params = ctx.params
  const res = ctx.res
  const repo = new CourseDetailRepo()

  try {
    const response = await repo.getCourseDetail((params?.slug as string) ?? "")

    if (response.statusCode === 200) {
      const body = JSON.parse(response.body)
      const result = body.result

      if (!result) {
        return {
          notFound: true,
        }
      } else {
        const schema = {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          name: result.course_name,
          description: result.course_description,
          thumbnailUrl: result.course_thumbnail?.course_thumbnail_path,
          uploadDate: result.course_created_date,
          contentUrl: result.course_info.introduction_video_link,
          embedUrl: result.course_info.introduction_video_link,
          duration: "PT5M0S", //di api tidak ada
          potentialAction: {
            "@type": "SeekToAction",
            target: result.course_info.introduction_video_link,
            "startOffset-input": "required name=seek_to_second_number",
          },
        }

        return {
          props: {
            data: result,
            schema,
          },
        }
      }
    } else {
      return {
        notFound: true,
      }
    }
  } catch (e) {
    res.setHeader("Location", "/")
    res.statusCode = 301

    return {
      notFound: true,
    }
  }
}

export default CourseDetailPage
